import { IMultiSuggestResult } from '@cian/geosuggest-widget';
import { mapCities } from './mapCities';
import { mapUndergrounds } from './mapUndergrounds';
import { mapRoads } from './mapRoads';
import { mapDistricts } from './mapDistricts';
import { ISuggestRealtorFormResponse } from '../../repositories/geo-suggest/v1/suggest-realtor-form';
import { pickBy } from 'ramda';

export const prepareSuggestions = ({ suggestions, sortOrder }: ISuggestRealtorFormResponse): IMultiSuggestResult => {
  return {
    sortOrder,
    suggestions: pickBy(value => value.length, {
      cities: mapCities(suggestions.cities || []),
      undergrounds: mapUndergrounds(suggestions.undergrounds || []),
      roads: mapRoads(suggestions.roads || []),
      districts: mapDistricts(suggestions.districts || []),
    }),
  };
};
